import axios from "axios";
import { urlAPI } from "../../config/config";
import { showSnackbar } from "../../redux/actions";
import { ICompanyFormValues } from "../../interface/company";
import { normalizeMonths } from "../../components/function/normalizeMonths";

export const addUpdateCompany = async (
    token: string,
    values: ICompanyFormValues,
    forecastId: string,
    version: number,
    setOpenModal: Function,
    dispatch: Function,
    setError: Function,
    companyId? : string
) => {
  const normalizedValues = {
    ...values,
    months: normalizeMonths(values.months)
  };
    try {
        if(!companyId){


       
          const response = await axios.post(`${urlAPI}/forecast/company/add`,
            { ...normalizedValues, forecastId, forecastVersion: version },
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
        } 
        else{
          const response = await axios.post(`${urlAPI}/forecast/company/update/${companyId}`,
            { ...normalizedValues, forecastId, forecastVersion: version },
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
        }       
        setOpenModal(false);
        dispatch(showSnackbar("Frais d'entreprise enregistré avec succès.", "success"));
      } catch (error: any) {
        if (error.response) {
          console.error("Erreur API :", error.response.data);
          console.error("Statut :", error.response.status);
        } else if (error.request) {
          console.error("Erreur de requête :", error.request);
        } else {
          console.error("Erreur :", error.message);
        }
  
        setError("Impossible d'enregistrer l'épargne'. Veuillez réessayer.");
        dispatch(showSnackbar("Erreur lors de l'enregistrement.", "error"));
      }
};
